import * as React from "react";
import { bannerAutoReply, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { WxBanner } from "../../components/wx-banner";
import { VerticalCard } from "../../components/vertical-card";
import { TabCards } from "../../components/tab-cards";
import { WxOurInfomation } from "../../components/our-infomation";
import { Footer } from "@/components";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./index.less";

const SCENE_DATA = [
  {
    imgUrl: require("@/assets/images/wx/icon/xiaoxi.png"),
    align: "left" as "left",
    title: "多条消息",
    descList: ["被关注自动回复、消息自动回复时", "可同时发送多条消息回复"],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/yanshi.png"),
    align: "left" as "left",
    title: "延时回复",
    descList: [
      "多条消息回复时可选择延时发送",
      "选择顺序发送时可设置消息发送间隔",
      "可设置免打扰时段",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/huifu.png"),
    align: "left" as "left",
    title: "自动回复打标签",
    descList: [
      "关键词自动回复时，自动给用户打标签",
      "可针对不同标签的粉丝进行",
      "精细化内容推送",
    ],
  },
];

const MASS_TYPE = [
  {
    imgUrl: require('@/assets/images/wx/img/keyword-reply.png'),
    align: "center" as "center",
    title: "关键词回复",
    descList: [
      "突破微信数量限制",
      "可设置模糊匹配、完全匹配关键词",
      "支持多条消息回复",
      "支持插入粉丝昵称、表情、链接文字、跳转文字",
    ],
  },
  {
    imgUrl: require('@/assets/images/wx/img/follow-reply.png'),
    align: "center" as "center",
    title: "被关注回复",
    descList: [
      "设置被关注后的回复",
      "支持多条消息延时回复",
      "支持小程序消息回复",
      "支持插入粉丝昵称、表情、链接文字、跳转文字",
    ],
  },
  {
    imgUrl: require('@/assets/images/wx/img/msg-reply.png'),
    align: "center" as "center",
    title: "消息自动回复",
    descList: [
      "没有匹配的关键词时触发",
      "支持多条消息延时回复",
      "支持插入粉丝昵称、表情、链接文字、跳转文字",
    ],
  },
];

const TAB_CARDS = [
  {
    img: require("@/assets/images/wx/img/tab-post.png"),
    icon: require("@/assets/images/wx/small-icon/22@3x.png"),
    title: "图文消息",
    desc: "部分场景可选择多条图文消息",
  },
  {
    img: require("@/assets/images/wx/img/tab-group-link.png"),
    icon: require("@/assets/images/wx/small-icon/21@3x.png"),
    title: "链接组",
    desc: "设置链接、标题、描述、缩略图后即可回复",
  },
  {
    img: require("@/assets/images/wx/img/tab-intelligent-text.png"),
    icon: require("@/assets/images/wx/small-icon/20@3x.png"),
    title: "智能文本",
    desc: "文本类型的回复，文中支持插入粉丝昵称、表情互动文字、跳转文字",
  },
  {
    img: require("@/assets/images/wx/img/tab-img-reply.png"),
    icon: require("@/assets/images/wx/small-icon/19@3x.png"),
    title: "图片回复",
    desc: "上传消息回复所需的图片",
  },
  {
    img: require("@/assets/images/wx/img/tab-mp.png"),
    icon: require("@/assets/images/wx/small-icon/18@3x.png"),
    title: "小程序",
    desc: "可选择展示方式：文字、小程序卡片",
  },
];

const block = genBlock("wx-auto-reply");

const WxAutoReply: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO['auto-reply'].keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO['auto-reply'].description);
  }, [])

  return (
    <div className={block()}>
      <WxBanner
        img={bannerAutoReply}
        btnText="立即使用"
        className={block('banner')}
        btnClick={isWap() ? null : "/v3/weixin/list"}
      />
      <div className={block("feature")}>
        <div className={block("feature-title")}>特色功能</div>
        <div className={block("feature-wrap")}>
          {SCENE_DATA.map((item) => (
            <VerticalCard
              {...item}
              style={{ padding: "10px 20px 10px 30px" }}
            />
          ))}
        </div>
      </div>
      <div className={block("reply-type")}>
        <div className={block("type-title")}>三种回复类型</div>
        <div className={block("type-wrap")}>
          {MASS_TYPE.map((item) => (
            <VerticalCard {...item} isDescIcon />
          ))}
        </div>
      </div>
      <TabCards list={TAB_CARDS} title="五大消息类型" />
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxAutoReply;
